// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";

/* Store Custom Code - Start */
import StoreCheckoutInformationBox from "@store/Library/Components/Foundation/StoreCheckout/StoreCheckoutInformationBox";
import StoreCheckoutInformationBoxSection from "@store/Library/Components/Foundation/StoreCheckout/StoreCheckoutInformationBoxSection";
/* Store Custom Code - End */

interface RowModel {
    fields: {
        rowId: string;
    };
}

const enum fields {
    rows = "rows",
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.rows]: RowModel[];
        [fields.title]: string;
    };
}

type Props = OwnProps;

const DashboardBoxWrapper: FC<Props> = ({ id, fields: { rows, title } }) => {
    return (
        <>
            <StoreCheckoutInformationBox title={title}>
                {rows.map((row, index) => {
                    const key = `${row.fields.rowId}-${index}`;
                    return (
                        <StoreCheckoutInformationBoxSection key={key}>
                            <Zone contentId={id} zoneName={`Row-${key}`} />
                        </StoreCheckoutInformationBoxSection>
                    );
                })}
            </StoreCheckoutInformationBox>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: DashboardBoxWrapper,
    definition: {
        group: "Common",
        displayName: "Dashboard Box",
        fieldDefinitions: [
            {
                name: "title",
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: false,
            },
            {
                name: fields.rows,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { rowId } }) => rowId,
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "rowId",
                        displayName: "Row ID",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
